import React, { useEffect, useState } from 'react';
import LoginLogForm from '../../../components/masters/users/loginLogs/LoginLogForm';
import LoginLogTable from '../../../components/masters/users/loginLogs/LoginLogTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../../../redux/actions/masters/users/user/userAction';
import { fetchLoginLogs } from '../../../redux/actions/masters/users/loginLog/loginLogAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .loginlog-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .loginlog-form, .loginlog-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const LoginLogNavTabPage = () => {
  const dispatch = useDispatch();
  const { list: users } = useSelector((state) => state.users);
  const { list: logs, loading, error } = useSelector((state) => state.loginLogs);
  const [selectedUser, setSelectedUser] = useState('');
  const [showLogs, setShowLogs] = useState(false);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    if (showLogs && selectedUser) dispatch(fetchLoginLogs(selectedUser));
  }, [dispatch, selectedUser, showLogs]);

  const handleUserChange = (userId) => {
    setSelectedUser(userId);
    setShowLogs(false);
  };

  const handleShowLogs = () => {
    setShowLogs(true);
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="loginlog-flex">
        <div style={tableContainer} className="loginlog-table">
          {showLogs && selectedUser ? (
            <LoginLogTable logs={logs} loading={loading} error={error} />
          ) : (
            <div style={{ color: '#888', textAlign: 'center', marginTop: 40 }}>Select a user and click "Show Logs" to view login history.</div>
          )}
        </div>
        <div style={formContainer} className="loginlog-form">
          <LoginLogForm
            users={users}
            selectedUser={selectedUser}
            onUserChange={handleUserChange}
            onSubmit={handleShowLogs}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginLogNavTabPage; 